module.exports = __webpack_public_path__ + "img/dataset-v2-env.ad9974ee.png";